<div
  class="w-100 navbarContent d-flex justify-content-between align-items-center"
>
  <div
    class="d-flex align-items-center cursor-pointer"
    (click)="redirectToRegistration()"
  >
    <img src="../../../../assets/images/Logo.png" class="logoImg mt-1" />
    <h3 class="text-light mt-3 logoDivText">SimpliEd</h3>
  </div>
  <div class="prof-drop d-flex align-items-center">
    <p class="admission-text">Admission</p>
  </div>
</div>
